import { lazy } from 'react'
export const ScoutSignup = lazy(() => import('../pages/Scout/ScoutSignup/ScoutSignup'))
export const LoginScouts = lazy(() => import('../components/LoginForm/LoginScouts'))

export const ScoutOnboarding = lazy(() => import('../pages/ScoutOnboarding/ScoutOnboarding'))
export const Step06Congratulations = lazy(() =>
  import('../pages/ScoutOnboarding/Step06Congratulations/Step06Congratulations'),
)
export const ScoutEmailConfirmPage = lazy(() =>
  import('../pages/Scout/ScoutEmailConfirmPage/ScoutEmailConfirmPage'),
)

// With ScoutLayout Pages
export const ScoutProfile = lazy(() => import('../pages/ScoutPortal/ScoutProfile/ScoutProfile.js'))
export const ScoutSettings = lazy(() => import('../pages/ScoutPortal/ScoutSettings/ScoutSettings.js'))
export const ScoutInvite = lazy(() => import('../pages/ScoutPortal/ScoutInvite/ScoutInvite.js'))
export const ScoutSettingsAddRecipient = lazy(() =>
  import('../pages/ScoutPortal/ScoutSettings/components/AddCarryRecipient.jsx'),
)
export const ScoutDeals = lazy(() => import('../pages/ScoutPortal/ScoutDeals/ScoutDeals.js'))
export const ScoutReferrals = lazy(() => import('../pages/ScoutPortal/ScoutReferrals/ScoutReferrals.js'))
export const ScoutContracts = lazy(() => import('../pages/ScoutPortal/ScoutContracts/ScoutContracts.js'))
export const ScoutContractsAddEntity = lazy(() =>
  import('../pages/ScoutPortal/ScoutContracts/ScoutEntityFlow/ScoutEntityFlow.js'),
)
export const ScoutNotifications = lazy(() =>
  import('../pages/ScoutPortal/ScoutNotifications/ScoutNotifications.js'),
)
export const ScoutInviteHistory = lazy(() =>
  import('../pages/ScoutPortal/ScoutInviteHistory/ScoutInviteHistory.js'),
)
